import React, { useContext, useState } from 'react';
import { IconButton, Tooltip, Box, Typography } from '@mui/material';
import ShareIcon from '@mui/icons-material/Share';
import { SettingsContext } from '../../contexts/SettingsContext';

interface ShareButtonProps {
    onClick: () => void;
}

const ShareButton: React.FC<ShareButtonProps> = ({ onClick }) => {
    const { settings } = useContext(SettingsContext);
    const [copied, setCopied] = useState(false);

    const handleClick = () => {
        onClick();
        setCopied(true);
        setTimeout(() => {
            setCopied(false);
        }, 2000);
    };

    return (
        <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
            <Tooltip title="Share" arrow>
                <IconButton
                    onClick={handleClick}
                    sx={{
                        color: settings.backgroundColor,
                    }}
                >
                    <ShareIcon sx={{ fontSize: 36 }} />
                </IconButton>
            </Tooltip>
            {copied && (
                <Typography
                    variant="body2"
                    sx={{
                        color: settings.backgroundColor,
                        fontSize: '0.875rem',
                        fontWeight: 500,
                        whiteSpace: 'nowrap',
                        animation: 'fadeIn 0.3s ease-in',
                        '@keyframes fadeIn': {
                            from: { opacity: 0 },
                            to: { opacity: 1 },
                        },
                    }}
                >
                    Link copied to clipboard
                </Typography>
            )}
        </Box>
    );
};

export default ShareButton;